<template>
  <div>
    <InfoPanel
        v-model:is-open="infoPanelIsOpen"
        :current-pokemon="infoPanelCurrentPokemon"
        @pokemon-sold="removePokemon"
        @pokemon-nickname-changed="nicknameChanged"
        @wonder-trade="wonderTrade"
        @buddy-changed="buddyChanged"
        @lock-changed="lockChanged"
        @usedItem="
        async () => {
          await refreshView();openInfoPanel(getUpdatedCurrentPokemon(infoPanelCurrentPokemon));
        }
      "
    />

    <div class="container">
      <div class="row p-3">
        <input
            type="text"
            :value="input_pokemon"
            placeholder="Search..."
            style="width: 42%; margin-right: 2px;"
            v-on:input="
            input_pokemon = $event.target.value;
            filter(input_pokemon);
          "
        />

        <Multiselect
            style="width: 39%"
            v-model="current_selected_in_multiselect"
            :options="options"
            :maxHeight="250"
            :show-labels="false"
            :searchable="false"
            :allow-empty="false"
            track-by="id"
            label="name"
            v-bind:placeholder="translation.pokemonList.sortByID"
            @close="dynamicSort(current_selected_in_multiselect.id)"
        />

        <button
            class="btn btn-link"
            style="color: black; width: 17%"
            v-bind:title="translation.general.changeSort"
            :disabled="isLoading || isBlocked"
            @click="changeAscDesc()"
        >
          <svg
              v-if="sortOrder"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
          >
            <path
                fill="currentColor"
                d="M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z"
            />
          </svg>
          <svg v-else style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z"
            />
          </svg>
        </button>
      </div>

      <div style="margin-top: -15px;font-size: 11px;display: flex;">
        Filters: &nbsp;
        <p style="color: #ffb700;">Name</p> &nbsp;&nbsp;&nbsp;
        <p style="color: deepskyblue;">#id</p> &nbsp;&nbsp;&nbsp;
        <p style="color: #ffb700;">!b &lt;bst&gt;</p>&nbsp;&nbsp;&nbsp;
        <p style="color: deepskyblue;"> !t &lt;type&gt;</p>&nbsp;&nbsp;&nbsp;
      </div>

      <h5 class="pokemon-list__title">
        {{ translation.pokemonList.pokemonListHeadline }}:
        {{ allPokemon.length }}
      </h5>

      <div class="row p-2">
        <div
            class="col-3 pokemon-list__entry"
            v-for="pokemon in allPokemon"
            v-bind:key="pokemon.id"
        >
          <PokemonEntryButton
              :pokedex-id="pokemon.pokedexId"
              :id="pokemon.id"
              :name="pokemon.name"
              :nickname="pokemon.nickname"
              :is-shiny="pokemon.isShiny"
              :sell-price="pokemon.sellPrice"
              :lvl="pokemon.lvl"
              :hpPercent="pokemon.hpPercent"
              :team-slot="pokemon.teamSlot"
              :status-effect="pokemon.statusEffect"
              :is-buddy="pokemon.isBuddy"
              :special-variant="pokemon.specialVariant"
              @click="openInfoPanel(pokemon)"
              @contextmenu.prevent="addToTeamRightclick(pokemon)"
              :disabled="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {translation} from "@/utils/translations";
import {backendUri} from "@/utils/settings";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import {ref} from "@vue/reactivity";
import {onMounted} from "@vue/runtime-core";
import InfoPanel from "./InfoPanel";
import {
  isLoading,
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {showModalMsg} from "@/components/Modal/modalUtils";
import Multiselect from "vue-multiselect";
import {handleUnknownError, sort_by} from "@/utils/utilities";
import {isBlocked} from "../../components/ButtonControl/ButtonControl";

import {ALL_TYPES} from "../../utils/pokemonConstants";
import {PokeApi} from "../../services/pokeapi";
import {PCGApi} from "../../services/pcg";

export default {
  name: "PokemonList",
  components: {
    InfoPanel,
    PokemonEntryButton,
    Multiselect,
  },
  data() {
    return {
      options: [
        {id: 0, name: translation.pokemonList.sortByID},
        {id: 1, name: translation.pokemonList.sortByName},
        {id: 2, name: translation.pokemonList.sortByRecent},
        {id: 3, name: translation.pokemonList.sortByAvgIV},
        {id: 4, name: translation.pokemonList.sortByPrice},
        {id: 5, name: translation.pokemonList.sortByLevel},
        {id: 6, name: translation.pokemonList.sortByHP},
        {id: 7, name: translation.pokemonList.sortByShiny},
        {id: 8, name: translation.pokemonList.sortByBaseStat},
      ],
    };
  },
  setup() {
    const allPokemon = ref([]);
    const allPokemonUnfiltered = ref([]);
    const attrFilter = ref("id");
    const sortOrder = ref(true);
    const input_pokemon = ref("");
    const current_selected_in_multiselect = ref({id: 0, name: translation.pokemonList.sortByID});

    const refreshView = async () => {
      startLoadingProcess();
      await axios
          .get(backendUri + "api/game/ext/trainer/pokemon-new/")
          .then((resp) => {
            allPokemon.value = [];
            for (let pokemon in resp.data.allPokemon) {
              let pkm = resp.data.allPokemon[pokemon];
              pkm.caughtAt = new Date(pkm.caughtAt);
              allPokemon.value.push(pkm);
            }
            allPokemonUnfiltered.value = allPokemon.value;

            reapplySearchFilters();

          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();
    });

    const infoPanelIsOpen = ref(false);
    const infoPanelCurrentPokemon = ref({});
    const openInfoPanel = async (pkm) => {
      startLoadingProcess();
      try {
        const pokeInfo = await PCGApi.Trainer.getTrainerPokeInfo(pkm.id);

        infoPanelIsOpen.value = true;
        infoPanelCurrentPokemon.value = {
          ...pkm,
          ...pokeInfo,
        };
      } catch (error) {
        if (error.response.data.error === 10) {
          showModalMsg(translation.pokemonList.sellNotExists);
        } else {
          handleUnknownError(error);
        }
      }

      stopLoadingProcess();
    };

    const wonderTrade = async (pkm) => {
      infoPanelIsOpen.value = false;

      removePokemon(infoPanelCurrentPokemon.value.id);
      addPokemon(pkm);
      openInfoPanel(pkm);
    };

    const sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const debounce = (callback, wait) => {
      let timeout;

      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          callback.apply(this, args);
        }, wait);
      };
    };

    const filter = debounce(async (text) => {
      startLoadingProcess();

      await sleep(450);
      if (text[0] === "!") {
        await advancedFilter(text);
      } else if (text[0] === "#") {
        await filterByID(text);
      } else {
        await filterByName(text);
      }

      stopLoadingProcess();
    }, 500);

    const advancedFilter = async (text) => {
      let filtered = [];

      let terms = text.match(/(!\w\s(\w+\s?\+?\s?\w+))/g);
      if (terms === -1 || terms === null) return;

      for (const element of terms) {
        try {
          if (element.includes("!t")) {
            let pokemons =
                filtered.length > 0 ? filtered : allPokemonUnfiltered.value;
            const parameters = element.match(/!t(.*)/)[1].trim();

            if (parameters === null) continue;

            const result = await filterByType(parameters, pokemons);

            filtered = result;
          }

          if (element.includes("!b")) {
            let pokemons =
                filtered.length > 0 ? filtered : allPokemonUnfiltered.value;

            const parameters = element.match(/!b(.*)/)[1].trim();

            if (parameters === null) continue;

            const result = filterByBaseStats(parameters, pokemons);

            filtered = result;
          }

          // if (element.includes("!g")) {
          //   console.log("filter by gen");
          //   let pokemons = filtered.length > 0 ? filtered : allPokemonUnfiltered.value;
          //
          //   const parameters = element.match(/!g(.*)/)[1].trim();
          //
          //   if (parameters === null) continue;
          //
          //   const result = filterByGeneration(parameters, pokemons);
          //
          //   filtered = result;
          // }
        } catch {
          // console.warn("User is typing...");
        }
      }

      allPokemon.value = filtered;
    };

    const reapplySearchFilters = () => {
      dynamicSort(current_selected_in_multiselect.value.id);
      if (input_pokemon.value.length > 0) {
        filter(input_pokemon.value);
      }
    }

    const filterByBaseStats = (parameters, pokemons) => {
      return pokemons.filter((x) => x.baseStats <= Number(parameters));
    };

    // const filterByGeneration = (parameters, pokemons) => {
    //   return pokemons.filter((x) => x.order <= Number(parameters));
    // };

    const filterByType = async (terms, pokemons) => {
      let types = terms.split("+").map((x) => x.trim().toLowerCase());

      if (types.length > 2) {
        return [];
      }

      for (const type of types) {
        if (!ALL_TYPES.includes(type)) {
          return [];
        }
      }

      let filtered = [];

      const typeIds = {};

      // get data for each type
      for (let type of types) {
        const typeData = await PokeApi.Types.getType(type);

        const ids = typeData.pokemon.map((x) => {
          const match = x.pokemon.url.match(/pokemon\/(\d+)/);

          return Number(match[1]);
        });

        typeIds[type] = ids;
      }

      let intersectionIds = [];

      if (Object.keys(typeIds).length === 2) {
        const typeOne = new Set(Object.values(typeIds)[0]);
        const typeTwo = new Set(Object.values(typeIds)[1]);

        intersectionIds = Array.from(
            new Set([...typeOne].filter((x) => typeTwo.has(x)))
        );
      } else {
        intersectionIds = Object.values(typeIds)[0];
      }

      for (const poke of pokemons) {
        const pokeapiDexId = PokeApi.Utils.pokeApiIdByOrder(poke);

        if (intersectionIds.includes(pokeapiDexId)) {
          filtered.push(poke);
        }
      }

      filtered = [...new Set(filtered)];

      return filtered;
    };

    const filterByID = async (pokedex_id) => {
      pokedex_id = pokedex_id.substring(1);

      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        if (parseInt(allPokemonUnfiltered.value[i].order) === parseInt(pokedex_id)) {
          tmp.push(allPokemonUnfiltered.value[i]);
        }
      }
      allPokemon.value = tmp;
    };

    const filterByName = async (name) => {
      name = name.toLowerCase()

      let tmp = [];
      for (let i = 0; i < allPokemonUnfiltered.value.length; i++) {
        let pkm_name = allPokemonUnfiltered.value[i].name.toLowerCase();

        let pkm_nickname = ""
        if (allPokemonUnfiltered.value[i].nickname !== null) {
          pkm_nickname = allPokemonUnfiltered.value[i].nickname.toLowerCase();
        }

        if (
            pkm_name.includes(name) || pkm_nickname.includes(name)
        ) {
          tmp.push(allPokemonUnfiltered.value[i]);
        }
      }
      allPokemon.value = tmp;
    };

    let sortProperty = ref("order");
    const dynamicSort = async (property) => {
      if (property === 0) {
        sortProperty = "order";
        sortOrder.value = false;
      } else if (property === 1) {
        sortProperty = "name";
        sortOrder.value = false;
      } else if (property === 2) {
        sortProperty = "caughtAt";
        sortOrder.value = true;
      } else if (property === 3) {
        sortProperty = "avgIV";
        sortOrder.value = true;
      } else if (property === 4) {
        sortProperty = "sellPrice";
        sortOrder.value = true;
      } else if (property === 5) {
        sortProperty = "lvl";
        sortOrder.value = true;
      } else if (property === 6) {
        sortProperty = "hpPercent";
        sortOrder.value = false;
      } else if (property === 7) {
        sortProperty = "isShiny";
        sortOrder.value = true;
      } else if (property === 8) {
        sortProperty = "baseStats";
        sortOrder.value = true;
      }

      allPokemon.value.sort(sort_by(sortProperty, sortOrder.value));
    };

    const changeAscDesc = async () => {
      sortOrder.value = !sortOrder.value;
      allPokemon.value.sort(sort_by(sortProperty, sortOrder.value));
    };

    const nicknameChanged = async (pkm_id, nickname) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        if (allPokemonUnfiltered.value[i].id === pkm_id) {
          allPokemonUnfiltered.value[i].nickname = nickname;
        }
        tmp.push(allPokemonUnfiltered.value[i]);
      }
      allPokemonUnfiltered.value = tmp;
      allPokemon.value = tmp;

      reapplySearchFilters();
    };

    const buddyChanged = async (pkm_id) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        allPokemonUnfiltered.value[i].isBuddy =
            allPokemonUnfiltered.value[i].id === pkm_id;
        tmp.push(allPokemonUnfiltered.value[i]);
      }
      allPokemonUnfiltered.value = tmp;
      allPokemon.value = tmp;

      reapplySearchFilters();
    };

    const lockChanged = async (pkm_id, locked) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        if (allPokemonUnfiltered.value[i].id === pkm_id) {
          allPokemonUnfiltered.value[i].locked = locked;
        }
        tmp.push(allPokemonUnfiltered.value[i]);
      }
      allPokemonUnfiltered.value = tmp;
      allPokemon.value = tmp;

      reapplySearchFilters();
    };

    const addToTeamRightclick = async (pkm) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-set-team/", {
            pokemon_id: pkm.id,
          })
          .then((resp) => {
            pkm.teamSlot = resp.data.slot;
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.PokemonAlreadyInTeam);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.PokemonTeamFull);
            } else if (error.response.data.error === 3) {
              showModalMsg(translation.pokemonList.PokemonNotOwnedAnymore);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    const addPokemon = async (pkm) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        tmp.push(allPokemonUnfiltered.value[i]);
      }
      tmp.push(pkm);
      allPokemonUnfiltered.value = tmp;
      allPokemon.value = tmp;

      allPokemon.value.sort(sort_by("pokedexId", false));
    };

    const removePokemon = async (pkm_id) => {
      var tmp = [];
      for (var i = 0; i < allPokemonUnfiltered.value.length; i++) {
        if (allPokemonUnfiltered.value[i].id === pkm_id) {
          continue;
        }
        tmp.push(allPokemonUnfiltered.value[i]);
      }
      allPokemonUnfiltered.value = tmp;
      allPokemon.value = tmp;
    };

    const getUpdatedCurrentPokemon = (pokemon) => {
      const instance = allPokemon.value.find((x) => x.id === pokemon.id);

      return instance;
    };

    return {
      translation,
      refreshView,
      allPokemon,
      infoPanelIsOpen,
      attrFilter,
      infoPanelCurrentPokemon,
      sortOrder,
      openInfoPanel,
      changeAscDesc,
      filter,
      dynamicSort,
      nicknameChanged,
      wonderTrade,
      removePokemon,
      buddyChanged,
      addToTeamRightclick,
      isBlocked,
      isLoading,
      getUpdatedCurrentPokemon,
      lockChanged,
      input_pokemon,
      current_selected_in_multiselect
    };
  },
};
</script>
<style lang="scss" scoped>
.pokemon-list {
  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>
